<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;padding-top: 20px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addBtn()">新增</el-button>
        <el-cascader v-if="$store.state.user.moduletag !== 2" v-fixZoom style="width: 300px" :options="treeData" v-model="orgid" :filterable="true" placeholder="请选择所属组织" clearable
                     :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}" ref="orgOptions">
        </el-cascader>
        <el-button v-if="$store.state.user.moduletag !== 2" type="success" @click="querySearchData()">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 120px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="event_time"
            label="消防活动时间"
            min-width="100"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="消防活动名称"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="desc"
            label="消防活动内容"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="location"
            label="地点"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="department"
            label="承办部门"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="promoter"
            label="召集人"
            min-width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="recorder"
            label="记录人"
            min-width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="participants"
            label="参与人员"
            min-width="100"
            align="center">
          </el-table-column>
          <el-table-column
            label="计划方案照片"
            min-width="120"
            align="center">
            <template slot-scope="scope">
              <img style="height: 100px" v-for="item in scope.row.plan_picture" :key="item.index" :src="item.url">
            </template>
          </el-table-column>
          <el-table-column
            label="签到照片"
            min-width="120"
            align="center">
            <template slot-scope="scope">
              <img style="height: 100px" v-for="item in scope.row.sign_picture" :key="item.index" :src="item.url">
            </template>
          </el-table-column>
          <el-table-column
            label="现场图片"
            min-width="190"
            align="center">
            <template slot-scope="scope">
              <img style="height: 100px" v-for="item in scope.row.live_picture" :key="item.index" :src="item.url">
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delBtn(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px" top="5vh"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-active :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-active>
    </el-dialog>
  </div>
</template>

<script>
import {deleteelderlyentertainments, queryelderlyentertainments} from '../../api/yanglaoyuan'
import {queryorg} from '../../api/organizer'
import addEditActive from './components/addEditActive'
import {getToken} from '../../utils/auth'
export default {
  name: 'safetyActivity',
  components: {addEditActive},
  data () {
    return {
      treeData: [],
      orgid: '',
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        treeData: [],
        entertainment_tag: 2,
        isAdd: true,
        row: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getOrgData()
    this.queryDataTable()
  },
  methods: {
    // 组织
    getOrgData () {
      this.treeData = []
      queryorg().then(res => {
        let orgData = res.data.org.filter(item => {
          if (item.org_type === 0) {
            return item
          }
        })
        // 所属组织
        let lastLevel = 100
        const arr = orgData
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
        this.addEditObj.treeData = this.treeData
      }).catch(() => {})
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    querySearchData () {
      this.currentPage = 1
      this.queryDataTable()
    },
    queryDataTable () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId,
        entertainment_tag: 2,
        orgid: this.orgid === '' ? this.$store.state.user.orgid : this.orgid,
        cid: 0,
        bid: 0
      }
      queryelderlyentertainments(params, data).then(res => {
        let table = []
        let arr = res.data.elderlyentertainments
        for (let i = 0; i < arr.length; i++) {
          let obj = arr[i]
          obj.plan_picture = this.getImgUrls(obj.plan_picture)
          obj.live_picture = this.getImgUrls(obj.live_picture)
          obj.sign_picture = this.getImgUrls(obj.sign_picture)
          table.push(obj)
        }

        this.tableData = table
        this.totalCells = res.data.cnt
      })
    },
    getImgUrls (picture) {
      if (picture === '') {
        return []
      }
      let url = this.commonType.getapi() + 'staticfile/file/'
      let list = []
      let arr = picture.split(',')
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          let photoUrl = url + arr[i] + '?token=' + getToken()
          let obj = {
            filename: arr[i],
            url: photoUrl
          }
          list.push(obj)
        }
      }
      return list
    },
    addBtn () {
      this.addEditTitle = '新增消防活动'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑消防活动'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除该消防活动【' + row.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id,
          orgid: row.orgid,
          cid: row.cid,
          hid: row.hid
        }
        deleteelderlyentertainments(data).then(res => {
          this.$notify({title: '成功', message: '成功删除', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        })
      })
    },
    updateTable () {
      this.queryDataTable()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/safetyActivity.vue